import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import * as QueriesQL from "queries/blog-post";
import { isPublished } from "@common/schema/blog-post/status";

export const Sidebar = () => null;
export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params: { siteId, postId },
  },
}) => {
  const {
    values,
    parent: { base },
  } = useSectionContext();

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            Removing the post <b>{values.title}</b>?
            {isPublished(values)
              ? " Its page comes down with it — a visitor at its address gets nothing."
              : " It was never published, so nothing a visitor can see changes."}
          </Col>
        </Row>
        <Mutation
          mutation={QueriesQL.remove}
          update={QueriesQL.update()}
          onMutate={({ handler }) => {
            handler({
              variables: { siteId, postId },
            });
          }}
          onCompleted={() => {
            history.replace(base);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>
  );
};
